<style>

.tableDesign .el-input__inner{
  border: 0;
  text-align: center;
}
</style>
<template>
  <BasicLayout>
    <template #wrapper>
      <Reward ref="RewardRef" :single="true" />
      <el-tabs active-name="0" tab-position="left" style="background-color: #ffffff;height: 800px" @tab-click="handleTabClick">
        <el-tab-pane name="0" label="分组配置">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row :gutter="10">
                <CommonExcel
                  ref="CommonExcelRef"
                  :import-p="'config:userLabel:import'"
                  :export-p="'config:userLabel:export'"
                  :import-method="importBaseCfg"
                  :export-method="exportBaseCfg"
                />
                <clear-cache-apply />
              </el-row>
            </div>
            <el-table size="mini" :data="baseList" border style="width: 100%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="序号" width="50">
                <template slot-scope="{row, $index}">
                  <span style="display:block">{{ $index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="最小等级" width="150">
                <template slot-scope="{row, $index}">
                  <el-input v-model="row.minLv" placeholder="最小等级" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="最大等级" width="150">
                <template slot-scope="{row, $index}">
                  <el-input v-model="row.maxLv" placeholder="最大等级" />
                </template>
              </el-table-column>
              <el-table-column label="用户分组" min-width="100%" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.groupIds" multiple>
                    <el-option v-for="item in groupsList" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="奖励配置" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.rewardId">
                    <el-option v-for="item in list[1]" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template slot-scope="{row,$index}">
                  <el-button size="mini" type="danger" @click="deleteBaseConfig($index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="addBaseConfig()">新增</el-button>
              <el-button type="primary" size="mini" style="margin:10px 10px" @click="handleSaveBase()">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane v-for="(item,type) in typeArr" :name="type" :label="item">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row :gutter="10" class="mb8">
                <CommonExcel
                  ref="CommonExcelRef2"
                  :import-p="'config:userLabel:import'"
                  :export-p="'config:userLabel:export'"
                  :import-method="importCfg"
                  :export-method="exportCfg"
                />
              </el-row>
            </div>
            <el-table class="tableDesign" size="mini" :data="list[type]" border style="width: 50%">
              <el-table-column label="序号" align="center" width="100">
                <template slot-scope="{row,$index}">
                  <span style="display:block;" :title="row.id">{{ $index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="名称" align="center">
                <template slot-scope="{row,$index}">
                  <el-input v-model="row.name" style="width: 250px;" placeholder="名称" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="{row,$index}">
                  <el-button type="primary" size="mini" @click="openDialog(row.config)">查看</el-button>
                  <el-button type="danger" size="mini" @click="handleDel($index,row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="handleAdd(type,'新增配置',[])">新增</el-button>
              <el-button v-prevent-re-click type="primary" size="mini" style="margin:10px 10px" @click="handleSaveConfig()">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
      <el-dialog title="提示" :visible.sync="dialog" width="60%">
        <el-table size="mini" :data="diaLogList" border fit highlight-current-row style="width: 100%;" height="500">
          <el-table-column label="序号" align="center" width="50">
            <template slot-scope="{row,$index}"><span> {{ $index + 1 }}</span></template>
          </el-table-column>
          <el-table-column label="是否开启" align="center" width="150">
            <template slot-scope="{row,$index}">
              <el-select v-model.number="row.isOpen" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="间隔" align="center" width="150">
            <template slot-scope="{row,$index}">
              <el-input-number v-model="row.interval" :controls="false" :min="1" placeholder="权重" style="width: 80%" />
            </template>
          </el-table-column>
          <el-table-column label="价格" align="center" width="200">
            <template slot-scope="{row,$index}">
              <el-select v-model="row.price" placeholder="请选择" @change="handleChangePrice(row)">
                <el-option v-for="item in skuList" :key="item.price" :label="item.price == 0 ? '免费' : item.price" :value="item.price" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="奖励" align="center">
            <template slot-scope="scope">
              <Reward v-model="scope.row.reward" />
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="{row,$index}">
              <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <span v-if="type == 1" slot="footer" class="dialog-footer" style="margin-right: 10px"><el-button size="small" type="primary" @click="addRewardDialogList">新增</el-button></span>
        <span slot="footer" class="dialog-footer"><el-button size="small" @click="dialog = false">关 闭</el-button></span>
      </el-dialog>
    </template>
  </BasicLayout>
</template>

<script>

import CommonExcel from '@/components/CommonExcel'
import Reward from '@/components/Reward'
import {
} from '@/api/config/run-for-money-cfg'
import { downloadExcelMultiSheet } from '@/utils/excel'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import { actionComAuxiliary, comAuxiliary, delComAuxiliary } from '@/api/config/activity-auxiliary-cfg'
import { Message } from 'element-ui'
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'
import { getSku } from '@/api/config/shop-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'

export default {
  name: 'PackUpgrade',
  components: { ClearCacheApply, CommonExcel, Reward },
  data() {
    return {
      loading: false,
      dialog: false,
      diaLogList: [],
      total: 0,
      list: [],
      type: 1,
      typeArr: { 1: '商品配置' },
      baseList: [],
      mapDialog: false,
      mapDialogList: [],
      groupsList: [],
      skuList: [],
      curClass: 'adGoodsGroupConfig',
      options: [{ label: '开启', value: 1 }, { label: '关闭', value: 0 }]
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getList()
      this.initBase()
    },
    initBase() {
      getUserTypeAllList().then(res => {
        res.data.forEach(res => {
          this.groupsList.push({ name: res.name, id: res.groupId })
        })
        getCommonCfg({ name: this.curClass }).then(res => {
          this.baseList = res.data
        })
        getSku({ type: 3 }).then(res => {
          this.skuList.push({ 'sid': 0, 'sku': '', 'price': 0, 'status': 1, 'tonNum': 0, 'starNum': 0 })
          this.skuList.push(...res.data)
        })
      })
    },
    openDialog(config) {
      this.dialog = true
      this.diaLogList = config
    },
    handleTabClick(val) {
      this.type = Number(val.name)
      this.diaLogList = []
    },
    handleSaveBase() {
      updateCommonCfg({ name: this.curClass, data: JSON.stringify(this.baseList) }).then(res => {
        this.msgSuccess('保存成功')
      })
    },
    importBaseCfg(excelInfo) {
      const excelData = excelInfo.data
      for (let i = 0; i < excelData.length; i++) {
        this.baseList = this.$refs.CommonExcelRef.tranToTarget(excelData[i].sheetData, { groupIds: this.groupsList, rewardId: this.list[2] }, true, 'name', 'id')
        break
      }
    },
    exportBaseCfg() {
      const fileName = '广告位礼包配置'
      const hearer = []
      const excelData = []
      const name = ['广告位礼包配置']
      const list = this.$refs.CommonExcelRef.tranToTarget(this.baseList, { groupIds: this.groupsList, rewardId: this.list[2] }, true, 'id', 'name')
      const tAk = this.$refs.CommonExcelRef.makeExcelData(list, { minLv: '最小等级', maxLv: '最大等级', groupIds: { name: '用户分组', sub: [] }, rewardId: '奖励配置' })
      hearer.push(tAk[0])
      excelData.push(tAk[1])
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    getList() {
      this.loading = true
      comAuxiliary({ class: this.curClass, select: 0 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
      })
    },
    handleDel(index, id) {
      if (id != 0) {
        delComAuxiliary({ idList: [id] })
      }
      this.list[this.type].splice(index, 1)
    },
    handleAdd(type, name, config) {
      this.list[type].push({ id: 0, name: name, class: this.curClass, type: type, config: config })
    },
    importCfg(updateInfo) {
      const excelData = updateInfo.data
      for (let i = 0; i < excelData.length; i++) {
        const sheet = excelData[i].sheetName
        let editFlag = false
        for (let j = 0; j < this.list[this.type].length; j++) {
          if (this.list[this.type][j].name == sheet) {
            for (let j = 0; j < excelData[i].sheetData.length; j++) {
              excelData[i].sheetData[j].reward = this.$refs.RewardRef.handleTranToVal(excelData[i].sheetData[j].reward)
            }
            this.list[this.type][j].config = excelData[i].sheetData
            editFlag = true
          }
        }
        if (!editFlag) {
          this.handleAdd(this.type, sheet, excelData[i].sheetData)
        }
      }
    },
    handleSaveConfig(type) {
      for (let i = 0; i < this.list[1].length; i++) {
        if (this.list[1][i].config.length != 4) {
          Message({ message: this.list[1][i].name + '商品配置长度不为4', type: 'error', duration: 5 * 1000 })
          return
        }
      }
      actionComAuxiliary({ class: this.curClass, list: this.list }).then(response => {
        this.msgSuccess('保存成功', () => {
          this.getList()
        }, 1000)
      })
    },
    exportCfg() {
      const nameArr = []
      const dataArr = []
      for (let i = 0; i < this.list[this.type].length; i++) {
        nameArr.push(this.list[this.type][i].name)
        dataArr.push(this.list[this.type][i].config)
      }
      this.onExport(this.type, nameArr, dataArr)
      return Promise.reject()
    },
    onExport(type, name, dataArr) {
      let fileName = ''
      const hearer = []
      const excelData = []
      if (type === 2) {
        fileName = '商品配置'
        for (let i = 0; i < dataArr.length; i++) {
          const row = JSON.parse(JSON.stringify(dataArr[i]))
          for (let j = 0; j < row.length; j++) {
            row[j].reward = this.$refs.RewardRef.handleTranToZH(row[j].reward)
          }
          const tAk = this.$refs.CommonExcelRef.makeExcelData(row, { isOpen: '是否开启', interval: '间隔', price: '价格', sku: 'sku', reward: { name: '奖励', sub: { propsId: '道具', num: '数量', val: '附加值' }}})
          hearer.push(tAk[0])
          excelData.push(tAk[1])
        }
      }
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    addBaseConfig() {
      this.baseList.push({ minLv: 1, maxLv: 999, groupIds: [], rewardId: 0 })
    },
    deleteBaseConfig(index) {
      this.baseList.splice(index, 1)
    },
    addRewardDialogList(index) {
      this.diaLogList.push({ isOpen: 1, interval: 1, price: 0, sku: '', reward: [] })
    },
    deleteRewardDialogList(index) {
      this.diaLogList.splice(index, 1)
    },
    handleChangePrice(row) {
      for (let i = 0; i < this.skuList.length; i++) {
        if (row.price === this.skuList[i].price) {
          row.sku = this.skuList[i].sku
          break
        }
      }
    }
  }
}
</script>

